import remoteMeta from './remoteMeta';

export {
    remoteMeta
};

if (process.env.NODE_ENV === 'development') {
    window.ducks = module.exports;
}
